import React, { useState, useEffect } from 'react';
import { Box, Card, Typography, Grid, Link, } from '@mui/material';
import Header from '../Header';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import { styles } from '../../styles/styles';
import { ContactUs } from "../../../services/operations/userOperations";
import CallIcon from '@mui/icons-material/Call';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import Footer from '../Footer';
import { FontStyles } from '../../styles/FontStyles';
const Contact = () => {
  const [contactus, setContactus] = useState([]);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        const response = await ContactUs();
        if (response.data) {
          setContactus(response.data);
        } else {
          console.log("Contact data error");
        }
      } catch (error) {
        console.error("Error fetching contact data:", error);
      }
    };

    fetchContact();
  }, []);
  const colorPalette = [
    "#FFEBEE", // Light Red
    "#FFF3E0", // Light Orange

    "#F1F8E9", // Light Green

    "#E1F5FE", // Light Blue
    "#EDE7F6", // Light Purple
    "#FCE4EC", // Light Pink
    "#F3E5F5", // Light Lavender



    "#F1F8FF", // Light Sky Blue
    "#E3F2FD", // Light Baby Blue
    "#F8BBD0", // Pastel Pink
    "#DCEDC8", // Pastel Green
    "#D1C4E9", // Soft Purple
    "#FFECB3", // Pale Orange
    "#C8E6C9", // Mint Green
    "#B2EBF2", // Pale Cyan


    "#B3E5FC"  // Pale Blue
  ];

  const branchColorMap = {};

  function getBackgroundColor(branchName) {
    const randomColor = colorPalette[Math.floor(Math.random() * colorPalette.length)];
    return randomColor
  }


  return (
    <>
      <Box>
        <Header />
      </Box>

      <Box sx={{ marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%" }, px: 2 }}>
        <Card sx={{ ...styles.contactcard, boxShadow: 3, p: 3 }}>
          <DecorativeCorner sx={{ top: -20, left: -20 }} />
          <DecorativeCorner sx={{ top: -20, right: -20 }} />
          <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
          <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

          <Typography variant="h4" component="h1" sx={{ ...FontStyles.heading1, mb: 4, textAlign: "center" }}>
            About Annapurna Marriages Contact Us
          </Typography>
          <Grid container spacing={3}>
            {contactus.map((item, index) => (
              <Grid item xs={12} md={6} key={index}>

                <Box
                  sx={{
                    backgroundColor: getBackgroundColor(),
                    borderRadius: 2,
                    p: 3,
                    position: "relative",
                    boxShadow: 3,

                  }}
                >
                  <Box sx={{ position: 'relative', mb: 3 }}>
                    <Box sx={{ position: 'absolute', top: -25, left: -25, zIndex: 2 }}>
                      <Box
                        sx={{
                          backgroundColor: '#fbc02d',
                          color: 'rgb(56, 48, 48)',
                          px: 2,
                          py: 0.5,
                          fontFamily: '"Inter var"',
                          fontWeight: { xs: 400, md: 700 },
                          fontSize: { xs: '15px', md: '18px' },
                          lineHeight: '100%',
                          letterSpacing: '0%',
                          border: "2px solid #fbc02d",
                          boxShadow: 1,
                        }}
                      >
                        {item.branchName?.toUpperCase()}
                      </Box>

                      <Box
                        sx={{
                          height: '10px',
                          backgroundColor: '#fbc02d',
                          border: "2px solid #fbc02d",
                          clipPath:
                            'polygon(0 0, 5% 100%, 10% 0, 15% 100%, 20% 0, 25% 100%, 30% 0, 35% 100%, 40% 0, 45% 100%, 50% 0, 55% 100%, 60% 0, 65% 100%, 70% 0, 75% 100%, 80% 0, 85% 100%, 90% 0, 95% 100%, 100% 0)',
                        }}
                      />
                    </Box>

                    <Box

                      sx={{
                        ...FontStyles.contactcitylabeldesign
                      }}
                    >

                      <Typography sx={{ ...FontStyles.citynameContactDetalies }}>
                        {item.city}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ textAlign: "start", display: "flex", flexDirection: "column", gap: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <LocationOnIcon sx={{ color: "black" }} />
                      <Typography sx={{ ...FontStyles.contactText }}>
                        Addrees: {item.address}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <EmailIcon sx={{ color: "black" }} />
                      <Typography sx={{ ...FontStyles.contactText,paddingY:{xs:"20px",md:"0px"} }}>
                        <Link
                          href={`mailto:${item.emailId}`}
                          underline="none"
                          sx={{
                            color: ' #1a1a1a;',
                            "&:hover": {
                              color: "rgba(10,20,40)",
                            },
                          }}
                        >
                          Email: {item.emailId}
                        </Link>
                      </Typography>

                    </Box>

                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                      < PhoneIcon sx={{ color: "black" }} />
                      <Typography sx={{ ...FontStyles.contactText }}>
                        Contact: +91 {item.phoneNumber}</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      ...FontStyles.mapdesignforcontact
                    }}
                  >
                    {item.mapUrl}
                  </Box>
                </Box>

              </Grid>
            ))}</Grid>
        </Card>
      </Box>
      <Footer />
    </>
  );
};

export default Contact;
